// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14f8b99d","239":"16d24002","455":"cd3f0c52"}[chunkId] + ".chunk.js";
};